import { useState } from 'react';
import DemoSection from '../DemoSection';
import { UIButton, UIDialog } from '../WebComponents';

export default function DialogDemo() {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <DemoSection title="Dialog 对话框" description="模态对话框">
      <DemoSection.Item title="基础用法">
        <div className="demo-content">
          <UIButton
            variant="primary"
            onUiClick={() => setDialogOpen(true)}
          >
            打开对话框
          </UIButton>
          <UIDialog
            open={dialogOpen}
            title="确认操作"
            message="确定要执行此操作吗？"
            onUiDialogCancel={() => setDialogOpen(false)}
            onUiDialogConfirm={() => {
              alert('已确认');
              setDialogOpen(false);
            }}
          />
        </div>
        <div className="code-block">
          <code>{`<UIButton
  variant="primary"
  onUiClick={() => setDialogOpen(true)}
>
  打开对话框
</UIButton>
<UIDialog
  open={dialogOpen}
  title="确认操作"
  message="确定要执行此操作吗？"
  onUiDialogCancel={() => setDialogOpen(false)}
  onUiDialogConfirm={() => {
    alert('已确认');
    setDialogOpen(false);
  }}
/>`}</code>
        </div>
      </DemoSection.Item>
    </DemoSection>
  );
}
